<mat-accordion id="work-order-line-tab-accordion" multi="true">
  <mat-expansion-panel id="line-details-panel" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mic-icon class="mr-2" icon="folder_open" fontSet="outlined"></mic-icon>
        {{ translationService.translate('lineDetailsText') }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-divider></mat-divider>
    <form id="work-order-line-form" [formGroup]="workOrderLineForm">
      <!-- Row 1: casingId, prodCustomer, processCode, workType, empty -->
      <div>
        <h3 class="mt-2 line-header">{{ translationService.translate('identificationText') }}</h3>
        <div class="form-grid">
          <mat-form-field
            id="casing-id-field"
            subscriptSizing="dynamic"
            class="filter-item mat-form-field-required"
            [ngClass]="workOrderEditable ? 'edit-component' : 'view-component'"
            [ngClass]="workOrderLineForm.get('casingId')?.hasError('required') ? 'min-field-height' : 'field-height'"
          >
            <mat-label>{{ translationService.translate('barCodeNumberText') }}</mat-label>
            <input
              id="casing-id-input"
              matInput
              type="text"
              formControlName="casingId"
              [readonly]="!workOrderEditable"
              maxlength="10"
              appAlphanumericOnly
            />
            @if(workOrderLineForm.get('casingId')?.hasError('required')){
            <mat-error>
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            }
          </mat-form-field>
          @if (workOrderEditable && prodCustomerOptionsDropdown?.length > 1) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="prod-customer-dropdown"
            formControlName="prodCustomer"
            [data]="prodCustomerOptionsDropdown"
            [widthConfig]="{ width: '100%' }"
            label="{{ translationService.translate('productionCustomerText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field
            id="prod-customer-field"
            subscriptSizing="dynamic"
            class="grid-item field-height"
            [ngClass]="isAdCustomerType && workOrderEditable ? 'edit-component mat-form-field-required' : 'view-component'"
          >
            <mat-label>{{ translationService.translate('productionCustomerText') }}</mat-label>
            <input
              id="prod-customer-input"
              matInput
              type="text"
              formControlName="prodCustomer"
              [readonly]="!isAdCustomerType || !workOrderEditable"
            />
            @if (isAdCustomerType && workOrderLineForm.get('prodCustomer')?.hasError('required')) {
            <mat-error>
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            }
          </mat-form-field>
          } @if (workOrderEditable && this.workOrderLine?.casingStatus !== 'SHOP_FLOOR') {
          <mic-dropdown-search
            micDropdownAccessibility
            id="process-code-dropdown"
            formControlName="processCode"
            [data]="processCodeOptions"
            [widthConfig]="{ width: '100%' }"
            label="{{ translationService.translate('casingProcessCodeText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [compareWith]="compareByValue"
            [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="process-code-field" subscriptSizing="dynamic" class="grid-item view-component field-height">
            <mat-label>{{ translationService.translate('casingProcessCodeText') }}</mat-label>
            <input
              id="process-code-input"
              matInput
              type="text"
              formControlName="processCode"
              [matTooltip]="
                translationService.translate('cannotModifyProcessCodesText') +
                ' ' +
                this.workOrderLine?.casingStatus +
                ' ' +
                translationService.translate('statusText')
              "
              matTooltipPosition="below"
              readonly
            />
          </mat-form-field>
          }
          <mat-form-field id="work-type-field" subscriptSizing="dynamic" class="grid-item field-height view-component disabled-field">
            <mat-label>{{ translationService.translate('workTypeText') }}</mat-label>
            <input id="work-type-input" matInput type="text" formControlName="workType" readonly />
          </mat-form-field>
          @if (workOrderLineExtended?.showMoldRadio) {
          <div id="mold-type-container" class="grid-item mold-type-border">
            <mat-radio-group id="mold-type-radio-group" formControlName="moldType" class="mic-radio-group" (change)="onMoldTypeChange()">
              <mat-radio-button value="P" [disabled]="!workOrderEditable">{{
                translationService.translate('hyphenPreMoldText')
              }}</mat-radio-button>
              <mat-radio-button value="M" [disabled]="!workOrderEditable">{{
                translationService.translate('customMoldText')
              }}</mat-radio-button>
            </mat-radio-group>
          </div>
          } @if (!workOrderLineExtended?.showMoldRadio) {
          <div class="grid-item empty-cell"></div>
          }
        </div>
      </div>
      <mat-divider></mat-divider>
      <div>
        <h3 class="mt-2 line-header">
          {{ translationService.translate('casingText') + ' ' + translationService.translate('dateText') }}
        </h3>
        <div class="form-grid">
          <mat-form-field
            id="casing-creation-dt-field"
            subscriptSizing="dynamic"
            class="grid-item field-height view-component disabled-field"
          >
            <mat-label>{{ translationService.translate('casingText') + ' ' + translationService.translate('creationDateText') }}</mat-label>
            <input id="casing-creation-dt-input" matInput type="text" formControlName="casingCreationDt" placeholder="-" readonly />
          </mat-form-field>
          <mat-form-field
            id="casing-receive-dt-field"
            subscriptSizing="dynamic"
            class="grid-item field-height view-component disabled-field"
          >
            <mat-label>{{ translationService.translate('casingText') + ' ' + translationService.translate('receivedDateText') }}</mat-label>
            <input id="casing-receive-dt-input" matInput type="text" formControlName="casingReceiveDt" placeholder="-" readonly />
          </mat-form-field>
          <mat-form-field
            id="casing-complete-dt-field"
            subscriptSizing="dynamic"
            class="grid-item field-height view-component disabled-field"
          >
            <mat-label>{{ translationService.translate('casingText') + ' ' + translationService.translate('completeDateText') }}</mat-label>
            <input id="casing-complete-dt-input" matInput type="text" formControlName="casingCompleteDt" placeholder="-" readonly />
          </mat-form-field>
        </div>
      </div>
      <mat-divider></mat-divider>
      <!-- Row 2: make, series, size, treadDesc, camSpecID -->
      <div>
        <h3 class="mt-2 line-header">{{ translationService.translate('casingSpecText') }}</h3>
        <div class="form-grid">
          @if (casingDetailsEditable) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="make-dropdown"
            formControlName="make"
            [data]="makeOptions"
            [widthConfig]="{ width: '100%' }"
            label="{{ translationService.translate('makeText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [compareWith]="compareByValue"
            [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="make-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('makeText') }}</mat-label>
            <input
              id="make-input"
              matInput
              type="text"
              formControlName="make"
              readonly
              [matTooltip]="translationService.translate('valuesCannotBeChangedText')"
              matTooltipPosition="below"
            />
          </mat-form-field>
          } @if (casingDetailsEditable) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="series-dropdown"
            formControlName="series"
            [data]="seriesOptions"
            [widthConfig]="{ width: '100%' }"
            label="{{ translationService.translate('seriesText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [compareWith]="compareByValue"
            [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="series-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('seriesText') }}</mat-label>
            <input
              id="series-input"
              matInput
              type="text"
              formControlName="series"
              readonly
              [matTooltip]="translationService.translate('valuesCannotBeChangedText')"
              matTooltipPosition="below"
            />
          </mat-form-field>
          } @if (casingDetailsEditable) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="size-dropdown"
            formControlName="size"
            [data]="sizeOptions"
            label="{{ translationService.translate('sizeText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="compareByValue"
            [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="size-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('sizeText') }}</mat-label>
            <input
              id="size-input"
              matInput
              type="text"
              formControlName="size"
              readonly
              [matTooltip]="translationService.translate('valuesCannotBeChangedText')"
              matTooltipPosition="below"
            />
          </mat-form-field>
          } @if (casingDetailsEditable && !treadDescReadOnly) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="tread-desc-dropdown"
            formControlName="treadDesc"
            [data]="treadDescOptions"
            label="{{ translationService.translate('treadDesignText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="compareByValue"
            [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="tread-desc-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('treadDesignText') }}</mat-label>
            <input
              id="tread-desc-input"
              matInput
              type="text"
              formControlName="treadDesc"
              readonly
              [matTooltip]="translationService.translate('valuesCannotBeChangedText')"
              matTooltipPosition="below"
            />
          </mat-form-field>
          }

          <mat-form-field id="tread-width-field" subscriptSizing="dynamic" class="grid-item field-height view-component disabled-field">
            <mat-label>{{ translationService.translate('widthText') }}</mat-label>
            <input id="tread-width-input" matInput type="text" formControlName="width" readonly />
          </mat-form-field>

          <mat-form-field id="cam-spec-id-field" subscriptSizing="dynamic" class="grid-item field-height view-component disabled-field">
            <mat-label>{{ translationService.translate('camSpecIdText') }}</mat-label>
            <input id="cam-spec-id-input" matInput type="text" formControlName="camSpecID" readonly />
          </mat-form-field>
        </div>
      </div>
      <mat-divider></mat-divider>

      <!-- Row 3: application, axle, ntr, mfgDOT, rtDOT -->
      <div>
        <h3 class="mt-2 line-header">{{ translationService.translate('usageAndLocalText') }}</h3>
        <div class="form-grid">
          @if (workOrderEditable) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="application-dropdown"
            formControlName="application"
            [data]="applicationOptions"
            label="{{ translationService.translate('applicationText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="codeAttribute"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="codeCompareWith"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="application-field" subscriptSizing="dynamic" class="grid-item field-height view-component">
            <mat-label>{{ translationService.translate('applicationText') }}</mat-label>
            <input id="application-input" matInput type="text" formControlName="application" readonly />
          </mat-form-field>
          } @if (workOrderEditable) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="axle-dropdown"
            formControlName="axle"
            [data]="axleOptions"
            label="{{ translationService.translate('axleText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="codeAttribute"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="codeCompareWith"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="axle-field" subscriptSizing="dynamic" class="grid-item field-height view-component">
            <mat-label>{{ translationService.translate('axleText') }}</mat-label>
            <input id="axle-input" matInput type="text" formControlName="axle" readonly />
          </mat-form-field>
          }
          <mat-form-field
            id="ntr-field"
            subscriptSizing="dynamic"
            class="grid-item"
            [ngClass]="workOrderLineForm.get('ntr')?.hasError('required') ? 'min-field-height' : 'field-height'"
            [ngClass]="workOrderEditable ? 'edit-component' : 'view-component'"
          >
            <mat-label>{{ translationService.translate('numberOfTimesRetreadedText') }}</mat-label>
            <input
              id="ntr-input"
              matInput
              type="text"
              formControlName="ntr"
              [readonly]="!workOrderEditable"
              inputmode="numeric"
              maxlength="1"
              pattern="^[0-9]$"
            />
            @if(workOrderLineForm.get('ntr')?.hasError('required')){
            <mat-error>
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            }
          </mat-form-field>
          <mat-form-field
            id="mfg-dot-field"
            subscriptSizing="dynamic"
            class="grid-item"
            [ngClass]="workOrderEditable ? 'edit-component' : 'view-component'"
            [ngClass]="workOrderLineForm.get('mfgDOT')?.hasError('required') ? 'min-field-height' : 'field-height'"
          >
            <mat-label>{{ translationService.translate('mfgDotText') }} (WWYY)</mat-label>
            <input id="mfg-dot-input" matInput type="text" formControlName="mfgDOT" [readonly]="!workOrderEditable" [maxLength]="4" />
            @if(workOrderLineForm.get('mfgDOT')?.hasError('required')){
            <mat-error>
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            }
          </mat-form-field>
          @if (showRtDotField) {
          <mat-form-field
            id="rt-dot-field"
            subscriptSizing="dynamic"
            class="grid-item"
            [ngClass]="workOrderEditable ? 'edit-component' : 'view-component'"
            [ngClass]="workOrderLineForm.get('rtDOT')?.hasError('required') ? 'min-field-height' : 'field-height'"
          >
            <mat-label>{{ translationService.translate('rtDotLabelText') }} (XXXWWYY)</mat-label>
            <input id="rt-dot-input" matInput type="text" formControlName="rtDOT" [readonly]="!workOrderEditable" [maxLength]="7" />
            @if(workOrderLineForm.get('rtDOT')?.hasError('required')){
            <mat-error>
              {{ translationService.translate('selectAtleastOneValueErrorText') || 'RT DOT is mandatory.' }}
            </mat-error>
            }
          </mat-form-field>
          }@else {
          <div class="grid-item empty-cell"></div>
          }
          <mat-form-field id="tread-depth-min-field" subscriptSizing="dynamic" class="grid-item field-height view-component disabled-field">
            <mat-label>{{ translationService.translate('treadDepthMinText') }}</mat-label>
            <input id="tread-depth-min-input" matInput type="text" formControlName="minTreadDepth" readonly />
          </mat-form-field>
          <mat-form-field id="tread-depth-max-field" subscriptSizing="dynamic" class="grid-item field-height view-component disabled-field">
            <mat-label>{{ translationService.translate('treadDepthMaxText') }}</mat-label>
            <input id="tread-depth-max-input" matInput type="text" formControlName="maxTreadDepth" readonly />
          </mat-form-field>
        </div>
      </div>
      <mat-divider></mat-divider>

      <!-- Row 4: -->
      <div>
        <h3 class="mt-2 line-header">{{ translationService.translate('gradingAndValueText') }}</h3>
        <div class="form-grid">
          <mat-form-field id="grade-field" subscriptSizing="dynamic" class="grid-item field-height view-component disabled-field">
            <mat-label>{{ translationService.translate('gradeText') }}</mat-label>
            <input id="grade-input" matInput type="text" formControlName="grade" readonly />
          </mat-form-field>
          @if (workOrderEditable) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="override-grade-dropdown"
            formControlName="overrideGrade"
            [data]="overrideGradeOptions"
            label="{{ translationService.translate('overRideGradeText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="compareByValue"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="override-grade-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('overRideGradeText') }}</mat-label>
            <input id="override-grade-input" matInput type="text" formControlName="overrideGrade" readonly />
          </mat-form-field>
          }
          <mat-form-field
            id="brand-field"
            subscriptSizing="dynamic"
            class="grid-item field-height"
            [ngClass]="workOrderEditable ? 'edit-component' : 'view-component'"
          >
            <mat-label>{{ translationService.translate('brandText') }}</mat-label>
            <input
              id="brand-input"
              matInput
              type="text"
              formControlName="brand"
              [readonly]="!workOrderEditable"
              maxlength="25"
              (input)="onBrandNumberInput($event)"
            />
            @if (workOrderLineForm.get('brand')?.hasError('maxlength')) {
            <mat-error>{{ translationService.translate('max25CharactersText') }}</mat-error>
            }
          </mat-form-field>
          @if (workOrderLineForm.get('casingValue')?.enabled) {
          <mat-form-field
            id="casing-value-field"
            subscriptSizing="dynamic"
            class="grid-item"
            [ngClass]="workOrderEditable ? 'edit-component' : 'view-component'"
            [ngClass]="workOrderLineForm.get('casingValue')?.hasError('required') ? 'min-field-height' : 'field-height'"
          >
            <mat-label>{{ translationService.translate('casingValueText') }}</mat-label>
            <input
              id="casing-value-input"
              matInput
              type="text"
              formControlName="casingValue"
              [readonly]="!workOrderEditable"
              inputmode="decimal"
              maxlength="9"
              pattern="^\d{1,9}(\.\d+)?$"
              (blur)="ensureCasingValueDefault()"
            />
            @if(workOrderLineForm.get('casingValue')?.hasError('required')){
            <mat-error>
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            }
          </mat-form-field>
          } @if (!workOrderLineForm.get('casingValue')?.enabled) {
          <div class="grid-item empty-cell"></div>
          }
          <div class="grid-item empty-cell"></div>
        </div>
      </div>
      <mat-divider></mat-divider>

      <!-- Row 5: Scrap Code fields group (Scrap Code, Description, Disposal Charge) -->
      @if (workOrderLineExtended?.showScrapFields || (workOrderEditable && isScrapCodeSelected)) {
      <div>
        <h3 class="mt-2 line-header">{{ translationService.translate('scrapAndDisposalText') }}</h3>
        <div class="form-grid">
          @if (workOrderEditable && isScrapCodeSelected) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="scrap-code-dropdown"
            formControlName="scrapCode"
            [data]="rejectReasonsOptions"
            label="{{ translationService.translate('scrapCodeText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="compareByCode"
            [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
          >
          </mic-dropdown-search>
          <mat-form-field subscriptSizing="dynamic" class="grid-item view-component field-height">
            <mat-label>{{ translationService.translate('disposalChargeDescriptionText') }}</mat-label>
            <input matInput type="text" formControlName="disposalCharge" readonly />
          </mat-form-field>
          <div class="grid-item empty-cell"></div>
          } @else {
          <mat-form-field id="scrap-code-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('scrapCodeText') }}</mat-label>
            <input id="scrap-code-input" matInput type="text" [value]="workOrderLineExtended?.scrapCode" readonly />
          </mat-form-field>
          <mat-form-field id="scrap-code-description-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('scrapCodeDescriptionText') }}</mat-label>
            <input id="scrap-code-description-input" matInput type="text" [value]="workOrderLineExtended?.scrapCodeDescription" readonly />
          </mat-form-field>
          <mat-form-field id="disposal-charge-description-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('disposalChargeDescriptionText') }}</mat-label>
            <input
              id="disposal-charge-description-input"
              matInput
              type="text"
              [value]="workOrderLineExtended?.disposalChargeDescription"
              readonly
            />
          </mat-form-field>
          }
        </div>
      </div>
      <mat-divider></mat-divider>
      }

      <!-- Row 6: NP Code fields group (NP Code, NP Code Description) -->
      @if (workOrderLineExtended?.showNpFields || isNpCodeSelected) {
      <div>
        <h3 class="mt-2 line-header">{{ translationService.translate('npCodeText') }}</h3>
        <div class="form-grid">
          @if (workOrderEditable && isNpCodeSelected) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="np-code-dropdown"
            formControlName="npCode"
            [data]="rejectReasonsOptions"
            label="{{ translationService.translate('npCodeText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="compareByCode"
            [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="np-code-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('npCodeText') }}</mat-label>
            <input id="np-code-input" matInput type="text" [value]="workOrderLineExtended?.npCode" readonly />
          </mat-form-field>
          <mat-form-field id="np-code-description-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('npCodeDescriptionText') }}</mat-label>
            <input id="np-code-description-input" matInput type="text" [value]="workOrderLineExtended?.npCodeDescription" readonly />
          </mat-form-field>
          }
        </div>
      </div>
      <mat-divider></mat-divider>
      }

      <!-- Row 7: wheelType, wheelColor-->
      <div>
        <h3 class="mt-2 line-header">{{ translationService.translate('wheelText') }}</h3>
        <div class="form-grid">
          @if (workOrderEditable) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="wheel-type-dropdown"
            formControlName="wheelType"
            [data]="wheelTypeOptions"
            label="{{ translationService.translate('wheelTypeText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="compareByValue"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="wheel-type-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('wheelTypeText') }}</mat-label>
            <input id="wheel-type-input" matInput type="text" formControlName="wheelType" readonly />
          </mat-form-field>
          } @if (workOrderEditable) {
          <mic-dropdown-search
            micDropdownAccessibility
            id="wheel-color-dropdown"
            formControlName="wheelColor"
            [data]="wheelColorOptions"
            label="{{ translationService.translate('wheelColorText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            [attribute]="'value'"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="compareByValue"
          >
          </mic-dropdown-search>
          } @else {
          <mat-form-field id="wheel-color-field" subscriptSizing="dynamic" class="grid-item view-component">
            <mat-label>{{ translationService.translate('wheelColorText') }}</mat-label>
            <input id="wheel-color-input" matInput type="text" formControlName="wheelColor" readonly />
          </mat-form-field>
          }
        </div>
      </div>
      <mat-divider></mat-divider>

      <!-- Row 8:  -->
      <div>
        <h3 class="mt-2 line-header">{{ translationService.translate('notesText') }}</h3>
        <div class="form-grid">
          <mat-form-field
            id="casing-notes-field"
            subscriptSizing="dynamic"
            class="grid-item casing-notes-span"
            [ngClass]="workOrderEditable ? 'edit-component' : 'view-component'"
          >
            <mat-label>{{ translationService.translate('casingNotesText') }}</mat-label>
            <textarea
              id="casing-notes-input"
              matInput
              formControlName="casingNotes"
              [readonly]="!workOrderEditable"
              class="casing-notes-textarea"
            ></textarea>
          </mat-form-field>
          @if(workOrderEditable && workOrderRequiredFieldFlag?.treadLengthRequired !== 'N') {
          <mic-dropdown-search
            micDropdownAccessibility
            id="length-field"
            formControlName="length"
            [data]="treadLengthOptions"
            label="{{ translationService.translate('lengthText') }}"
            searchPlaceholder="{{ translationService.translate('searchButtonText') }}"
            subscriptSizing="dynamic"
            id="treadLengthFieldEdit"
            [attribute]="'value'"
            [widthConfig]="{ width: '100%' }"
            [compareWith]="compareByValue"
            [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
          >
          </mic-dropdown-search>
          }@else if(!workOrderEditable && workOrderRequiredFieldFlag?.treadLengthRequired !== 'N') {
          <mat-form-field
            subscriptSizing="dynamic"
            id="treadLengthFieldView"
            class="grid-item field-height"
            [ngClass]="workOrderEditable ? 'edit-component' : 'view-component'"
          >
            <mat-label>{{ translationService.translate('lengthText') }}</mat-label>
            <input id="length-input" matInput type="text" formControlName="length" [readonly]="!workOrderEditable" />
          </mat-form-field>
          }@else{
          <div class="grid-item empty-cell"></div>
          }
        </div>
      </div>
    </form>
  </mat-expansion-panel>

  <!-- Repairs Accordion -->
  <mat-expansion-panel id="repairs-panel" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mic-icon class="mr-2" icon="build" fontSet="outlined"></mic-icon>
        {{ translationService.translate('repairsText') }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-divider></mat-divider>
    <mic-table id="repairs-table" class="my-repair-table table-stripped btn-table" [config]="tableConfig" [dataSource]="repairsDataSource">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>

      <!-- Custom status cell template using micCellTemplate -->
      <ng-container *micCellTemplate="let item; name: 'statusCell'">
        <div class="flex flex-row gap-1">
          @if (item.status === 'New') {
          <mic-status class="valid">{{ item.status }}</mic-status>
          } @if (item.status === 'Existing') {
          <mic-status class="primary">{{ item.status }}</mic-status>
          } @if (item.status === 'Wasted') {
          <mic-status class="yellow">{{ item.status }}</mic-status>
          }
        </div>
      </ng-container>
    </mic-table>
  </mat-expansion-panel>
</mat-accordion>
